<app-header-page>
    <app-component-button-header-back href="/account/tasks/{{alias ? 'all/' + alias : 'my'}}" [marginLeft]="'250px !important'">
        {{ 'HEADERS.EXIT_TASK' | translate }}
    </app-component-button-header-back>
    <span style="width: 100%; display: flex;justify-content: end;align-items: flex-end;">
        <button [routerLink]="['/account','tasks2','my' ]"
                mat-button
                style="font-weight: bold; font-size: medium; "
        >
            <lucide-icon style="margin-top: -4px;" size="18" name="arrow-left"></lucide-icon>
            {{ 'HEADERS.EXIT_TASK' | translate }}
        </button>
    </span>
</app-header-page>

<app-component-task-detail
        (emitOnDelete)="$event ? onDeleteTask($event) : null"
        (emitOnLoad)="onLoadTask($event)"
        [taskAlias]="taskId"
></app-component-task-detail>
